import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import {makeStyles} from "@mui/styles";

function ButtonContainer({
    children,
    className,
    addTopBorder
}) {
    const classes = useStyles();
    return (
        <div className="ButtonContainer">
            <div className={addTopBorder? clsx(className,classes.topBorder): className}>
                {
                    children
                }
            </div>
        </div>
    );
}

const useStyles = makeStyles({
    topBorder:{
        borderTop: '1px solid rgb(224, 228, 232)',
        paddingTop: '10px',
        marginTop: '15px'
    }
});

ButtonContainer.propTypes = {
    children: PropTypes.node
}

export default ButtonContainer;